import React from 'react';
import { Icon } from '@amzn/storm-ui';
import { SpinnerContainer } from './CustomSpinner.styles';

export const CustomSpinner = () => {
  return (
    <SpinnerContainer>
      <Icon type={'spinner'} size="2x" />
    </SpinnerContainer>
  );
};
